import { render, staticRenderFns } from "./adminViewPeaApproversByPEA.vue?vue&type=template&id=300afd88"
import script from "./adminViewPeaApproversByPEA.vue?vue&type=script&lang=js"
export * from "./adminViewPeaApproversByPEA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports